import React from 'react'

import { Dialog, Button, Flex, Text } from 'components/ds'

interface UnsavedChangesDialogProps {
  /**
   * Callback when user confirms they want to discard changes
   */
  onDiscard: () => void
  /**
   * Callback when user cancels and wants to continue editing
   */
  onContinueEditing: () => void
}

/**
 * A dialog that warns users about unsaved changes when attempting to leave
 * the Rights Management / Writers tab.
 *
 * Shows a confirmation dialog with "Continue editing" and "Discard" buttons.
 */
export function UnsavedChangesDialog({
  onDiscard,
  onContinueEditing,
}: UnsavedChangesDialogProps) {
  return (
    <Dialog.Root open>
      <Dialog.Content maxWidth="450px" aria-describedby={undefined}>
        <Dialog.Title>You have unsaved changes</Dialog.Title>
        <Text as="p" size="2">
          You haven’t saved your latest edits. Leaving now will discard them.
        </Text>

        <Flex gap="3" mt="4" justify="end">
          <Button
            variant="soft"
            color="gray"
            size="2"
            onClick={onContinueEditing}
          >
            Continue editing
          </Button>
          <Button variant="solid" color="red" size="2" onClick={onDiscard}>
            Discard
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}

export default UnsavedChangesDialog
